<template>
  <span class="hb-money" :class="[`hb-money--${size}`, `hb-money--${resolvedTone}`]">{{ formatted }}</span>
</template>

<script>
import { currencyFormatter } from '@/util/Util'

/**
 * Valor monetario do painel.
 *
 * Recebe SEMPRE centavos — e a unidade em que o modulo de influencers trafega dinheiro
 * (`*_cents` em toda a API). O `currencyFormatter` do app espera reais, entao a divisao
 * acontece aqui, num lugar so.
 *
 * A classe `hb-money` e o gancho da regra de ocultar valores em assets/scss/hubee-tokens.scss;
 * todo valor em dinheiro do painel precisa passar por este componente para ser coberto
 * pelo olho do cabecalho.
 */
export default {
  name: 'HbMoney',
  props: {
    cents: { type: Number, default: 0 },
    /** Prefixa + / − explicitamente. Para extrato, onde o sinal e a informacao. */
    signed: { type: Boolean, default: false },
    /**
     * `auto` deriva do sinal (so faz sentido junto de `signed`).
     * `brand` e a tinta da marca, usada nos saldos grandes.
     */
    tone: {
      type: String,
      default: 'default',
      validator: v => ['default', 'auto', 'brand', 'positive', 'negative', 'muted'].includes(v),
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg', 'xl'].includes(v),
    },
  },
  computed: {
    resolvedTone() {
      if (this.tone !== 'auto') return this.tone

      return Number(this.cents || 0) < 0 ? 'negative' : 'positive'
    },
    formatted() {
      const cents = Number(this.cents || 0)
      const value = Math.abs(cents) / 100
      const amount = currencyFormatter(value)

      if (!this.signed) return cents < 0 ? `− ${amount}` : amount

      // U+2212 (minus) em vez de hifen: alinha melhor com o + na coluna de valores.
      return `${cents < 0 ? '−' : '+'} ${amount}`
    },
  },
}
</script>

<style scoped>
.hb-money {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.hb-money--sm {
  font-size: var(--fs-sm);
}

.hb-money--lg {
  font-size: var(--fs-h2);
  font-weight: var(--fw-medium);
  line-height: 1.2;
}

.hb-money--xl {
  font-size: clamp(1.9rem, 3.4vw, 2.4rem);
  font-weight: var(--fw-medium);
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.hb-money--brand {
  color: var(--hubee-green);
}

.hb-money--positive {
  color: var(--success);
}

.hb-money--negative {
  color: var(--danger);
}

.hb-money--muted {
  color: var(--text-muted);
}
</style>
